import { createRef, useLayoutEffect } from 'react';

// Set image height to match content height
const useImageHeight = (isDesktop: boolean) => {

    const titleContentRef = createRef<HTMLDivElement>();
    const titleInnerContainerRef = createRef<HTMLDivElement>();

    useLayoutEffect(() => {
        if (titleContentRef.current && isDesktop) {
            titleInnerContainerRef.current.style.height = titleContentRef.current.scrollHeight + 'px';
        }
    }, []);

    return {
        titleContentRef,
        titleInnerContainerRef
    }
}

export default useImageHeight;